import { FC, ReactElement } from 'react';

import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import { Typography } from '@mui/material';

import ZendeskLoader from './ZendeskLoader';

const ZendeskLink: FC<{
  loadingText?: string;
  text?: string;
  textColor?: string;
}> = ({ loadingText = 'Loading...', text = 'Chat with us', textColor }) => {
  const generateUI = (text: string): ReactElement => {
    return (
      <Typography
        variant="body2"
        sx={{
          color: textColor,
          display: 'flex',
          alignItems: 'center',
          paddingLeft: 0,
        }}
      >
        <ChatBubbleOutlineIcon
          fontSize="small"
          sx={{ marginRight: '0.5rem' }}
        />
        {text}
      </Typography>
    );
  };

  return (
    <ZendeskLoader
      loadingIndicator={generateUI(loadingText)}
      sx={{ padding: 0 }}
    >
      {generateUI(text)}
    </ZendeskLoader>
  );
};

export default ZendeskLink;
